// Polis, Projections tab (17 October 2026): control of the chamber the election belongs to.
export default {
  titre: 'Control of {assemblee}',
  pct: '{n}%',
  moinsDeUn: '< 1',
  plusDe99: '> 99',
  fourchette: '{bas} ~ {haut}',
  aria: '{dem} seats to {rep}, out of {sieges}',
  verdict: {
    garde: '{camp} keep {assemblee} in {p} of cases.',
    prend: '{camp} take {assemblee} in {p} of cases.',
    obtient: '{camp} hold {assemblee} in {p} of cases.',
    autre: '{camp}, in {p}.',
    aucun: 'In {p}, an unaligned independent holds the balance.',
  },
  majorite: 'The line: the majority, {n} seats.',
  departage: 'In a tie, the Vice President breaks it for {camp}.',
  courses: {
    titre: 'The races',
    legende: 'the chance of winning for {camp}',
    classement: 'decided in advance',
    margeDem: 'Democrat +{n}',
    margeRep: 'Republican +{n}',
    egalite: 'tied',
    independant: '{nom} (independent)',
    jumeaux: 'twins {p}',
  },
  jumeaux: {
    titre: 'According to the twins:',
    sieges: '{campDem} {dem} seats, {campRep} {rep}.',
    controle: '{camp} hold it in {p} of cases.',
  },
  acquis: 'Not up: {dem} seats for {campDem} (including independents who caucus with them), {rep} for {campRep}.',
  jouees: 'Races decided in advance: {dem} for {campDem}, {rep} for {campRep}.',
  chambre: {
    national: 'Projected national vote: {marge}.',
    disputees: '{n} contested districts.',
    legende: 'The most contested, with the chance of winning for {camp}.',
  },
}
